import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Anomaly"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postAnomalyGetTable: build.query<
        PostAnomalyGetTableApiResponse,
        PostAnomalyGetTableApiArg
      >({
        query: (queryArg) => ({
          url: `/Anomaly/GetTable`,
          method: "POST",
          body: queryArg,
        }),
        providesTags: ["Anomaly"],
      }),
      postAnomalyGetDetailTable: build.query<
        PostAnomalyGetDetailTableApiResponse,
        PostAnomalyGetDetailTableApiArg
      >({
        query: (queryArg) => ({
          url: `/Anomaly/GetDetailTable`,
          method: "POST",
          body: queryArg.anomalyRequestDto,
          params: {
            measuringPoint: queryArg.measuringPoint,
            analysisCategory: queryArg.analysisCategory,
          },
        }),
        providesTags: ["Anomaly"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as anomalyApi };
export type PostAnomalyGetTableApiResponse =
  /** status 200 OK */ CellValueDto[][];
export type PostAnomalyGetTableApiArg = AnomalyRequestDto;
export type PostAnomalyGetDetailTableApiResponse =
  /** status 200 OK */ AnomalyDetailTableResultDtoRead[];
export type PostAnomalyGetDetailTableApiArg = {
  measuringPoint: string;
  analysisCategory: string;
  anomalyRequestDto: AnomalyRequestDto;
};
export type CellValueDto = {
  row: string;
  col: string;
  value?: number | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type SignificanceCategory = "low" | "medium" | "high";
export type AnomalyClassification = "c" | "v" | "d" | "e";
export type AnomalyRequestDto = {
  start: string;
  end: string;
  dataFieldIds: number[];
  measuringPointNames: string[];
  significanceCategory: SignificanceCategory[];
  classification: AnomalyClassification[];
};
export type DataFieldDto = {
  id: number;
  dataClass: string;
  name: string;
  description?: string | null;
  analysisCategory?: string | null;
  category?: string | null;
  subcategory?: string | null;
  unit?: string | null;
  isUsedForPqIndex: boolean;
  isUsedForAnomaly: boolean;
  isUsedForTrend: boolean;
  isUsedForCorrelation: boolean;
  twoTailedCalculation: boolean;
  pqIndexCategory?: string | null;
};
export type DataFieldDtoRead = {
  id: number;
  dataClass: string;
  name: string;
  description?: string | null;
  analysisCategory?: string | null;
  category?: string | null;
  subcategory?: string | null;
  unit?: string | null;
  isUsedForPqIndex: boolean;
  isUsedForAnomaly: boolean;
  isUsedForTrend: boolean;
  isUsedForCorrelation: boolean;
  twoTailedCalculation: boolean;
  pqIndexCategory?: string | null;
  isVoltageDataField: boolean;
  isThdDataField: boolean;
  isSimpleHarmonic: boolean;
  isInterHarmonic: boolean;
  isHighFrequencyHarmonic: boolean;
};
export type AnomalyDetailTableResultDto = {
  day: string;
  dataField: DataFieldDto;
  value: number;
  classification: AnomalyClassification[];
  significanceCategory: SignificanceCategory;
};
export type AnomalyDetailTableResultDtoRead = {
  day: string;
  dataField: DataFieldDtoRead;
  value: number;
  classification: AnomalyClassification[];
  significanceCategory: SignificanceCategory;
};
export const {
  usePostAnomalyGetTableQuery,
  useLazyPostAnomalyGetTableQuery,
  usePostAnomalyGetDetailTableQuery,
  useLazyPostAnomalyGetDetailTableQuery,
} = injectedRtkApi;
